import React, { Component } from 'react';
import _ from 'lodash'
import t from './translate/t'
import icons from './icons'

export default props => {
  const { candidate, differentOpinions } = props
  const percentage = props.percentage || 0

  return <div className="card w-full mb-6 text-sm">
    <div className="flex flex-row">
      <div className="flex justify-center items-center text-lg font-bold candidate-number bg-primary-light select-text">{candidate.number}</div>
      <div className="flex-1 candidate-content">
        <div className="flex flex-row px-2 pt-1">
          <div className="text-md flex-1 overflow-hidden select-text">{candidate.firstName} {candidate.lastName} <span className="text-md text-dark">({Math.round(percentage * 100) + '%'})</span></div>
          <div>
            {candidate.gender && t(candidate.gender) + ' '}
            {candidate.age && <span>{candidate.age}{t('age')}</span>}
            </div>
        </div>
        <div className="flex flex-row px-2">
          <div className="flex-1" title={candidate.title}>{_.truncate(candidate.title, { length: 40 })}</div>
          <div className="text-right">{candidate.city}</div>
        </div>
        <div className="flex flex-row px-2 pb-1 bg-light">
          <div className="flex-1 overflow-hidden select-text">{t(candidate.party)}</div>
          <div className="flex flex-row justify-end -mx-1">
            {candidate.fb && <div className="icon-container mx-1"><a href={'https://www.facebook.com/' + candidate.fb} rel="noopener noreferrer nofollow" target="_blank"><span dangerouslySetInnerHTML={{ __html: icons.fb }} /></a></div>}
            {candidate.tw && <div className="icon-container mx-1"><a href={'https://www.twitter.com/' + candidate.tw} rel="noopener noreferrer nofollow" target="_blank"><span dangerouslySetInnerHTML={{ __html: icons.tw }} /></a></div>}
            {candidate.website && <div className="icon-container mx-1 font-bold"><a href={candidate.website + '?ref=pikavaalikone.fi'} rel="noopener noreferrer nofollow" target="_blank">www</a></div>}
          </div>
        </div>
      </div>
    </div>
    {differentOpinions.length ? <div className="bg-light pt-1 px-2">
      {differentOpinions.map(opinion => <div key={opinion} className="pb-1">{t('Different opinion')}: {t(opinion)}</div>)}
    </div> : null}
  </div>
}
